import { useState } from 'react';
import Masonry from 'react-masonry-css';
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import BookData from '../data/bookData.json'

const BookSegment = ({genre}) => {

    const [value, setValue] = useState('');

    
    const breakPoints = {
        default: 4,
        1100: 3,
        700: 2
    }

    return ( 
    <div>

<Masonry breakpointCols={breakPoints}
                 className="my-masonry-grid"
                 columnClassName="my-masonry-grid_column">

        

        {BookData.slice(0).reverse().filter((data) => {
           
        if (value == {genre}){
            return data;
        }else if(data.genre.toLowerCase().includes(genre.toLowerCase())){
            return data;
        
        };
        
        
        }) .map((book, index) => {
            if(index < 8){
            return(<Fade>
        <Link to = { '/' + book.key + '/' + book.title.replace(/\s/g, "-")}>
            <div className= 'book'>
                
                
                <div className = 'single-book' key = {index}>
                    <img src = {book.cover} alt = '' loading='lazy'></img>
                <div className='book-information'>
                    <span className = 'book-titles'>{book.title}</span>
                    <span className = 'book-author'>{book.author}</span>
                </div>
                    
                </div>
                
                <div className='book-background'></div> 
            </div>
        </Link>
        </Fade>)}}
        
        
        
        
        )}


        </Masonry>
        
    </div> );
}
 
export default BookSegment;